import { useMessageSource } from "react-message-source";
import * as Yup from "yup";

export default function usePhoneNumberValidator() {
  const { getMessage } = useMessageSource();

  const maxNonSwissNumberLength = 15;
  return Yup.object()
    .nullable()
    .shape({
      code: Yup.string()
        .matches(
          /\+\d{1,4}/,
          getMessage("Validation.message-mustHaveSpecifiedFormat"),
        )
        .required(getMessage("Validation.message-required")),
      number: Yup.string().when("code", {
        is: "+41", // Swiss number
        then: () =>
          Yup.string()
            .matches(
              /\d{2} \d{3} \d{2} \d{2}/,
              getMessage("Validation.message-mustHaveSpecifiedFormat"),
            )
            .required(getMessage("Validation.message-required")),
        otherwise: () =>
          Yup.string()
            .matches(/\d+/, getMessage("Validation.message-mustContainDigits"))
            .max(
              maxNonSwissNumberLength,
              getMessage(
                "Validation.message-maxLengthDigits",
                maxNonSwissNumberLength,
              ),
            )
            .required(getMessage("Validation.message-required")),
      }),
    });
}
